import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import './Appointments.css';
import AppointmentsListTable from './AppointmentsListTable';
import PatientInfoPanel from './PatientInfoPanel/PatientInfoPanel';
import NewAppointment from './NewAppointment';
import ENDPOINTS from '../../Constants/ApiEndpoints';

const Appointments = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [appointmentFilters, setAppointmentFilters] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [patient, setPatient] = useState(location.state?.patient || null);
  const [loadingPatient, setLoadingPatient] = useState(!patient && !!id);

  const isNewAppointment = location.pathname.endsWith('/newAppointment');
  const isPatientView = location.pathname.includes('/patientInfoPanel/');

  useEffect(() => {
    const fetchPatientById = async () => {
      try {
        setLoadingPatient(true);
        setPatient(null);
        const response = await fetch(`${ENDPOINTS.GET_APPOINTMENT_DETAILS_BY_APPOINTMENT_ID}/${id}`, {
          credentials: 'include',
        });

        const data = await response.json();
        setPatient(data);
      } catch (error) {
        console.error('Failed to load patient', error);
      } finally {
        setLoadingPatient(false);
      }
    };

    if (id) {
      fetchPatientById();
    }
  }, [id]);

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  const handleSearch = ({ type, query }) => {
    setAppointmentFilters({ type, query });
  };

  if (isNewAppointment) {
    return <NewAppointment onBack={() => navigate(-1)} />;
  }

  if (isPatientView) {
    if (loadingPatient) {
      return (
        <div style={{ padding: '40px', textCenter: 'center', color: '#64748b' }}>
          Loading patient data...
        </div>
      );
    }

    if (patient) {
      return (
        <PatientInfoPanel
          patient={patient}
          onBack={() => navigate('/outpatient/appointments')}
        />
      );
    }

    return (
      <div style={{ padding: '40px', textCenter: 'center', color: '#64748b' }}>
        Patient Info not found.
      </div>
    );
  }

  return (
    <div className="appointments-page-wrapper">
      <AppointmentsListTable
        startDate={startDate}
        endDate={endDate}
        onDateChange={handleDateChange}
        onSearch={handleSearch}
        appointmentFilters={appointmentFilters}
        onNewAppointment={() => navigate('/outpatient/appointments/newAppointment')}
        onSelectPatient={(patient) =>
          navigate(`/outpatient/appointments/patientInfoPanel/${patient.appointmentId}`, {
            state: { patient },
          })
        }
      />
    </div>
  );
};

export default Appointments;
